import type { Room } from "../../../interfaces/interfaces";

export default [
  {
    name: "BL32",
    id: "b93cec2c-6da0-4b69-8cf8-a925a8832427",
  },
  {
    name: "BL33",
    id: "fd86f739-d763-440f-a0da-278ca5df39ae",
  },
  {
    name: "BL34",
    id: "7d1561b3-9245-434e-ada5-ddde80ba5a4c",
  },
  {
    name: "Ada Lovelace",
    id: "ae945d57-2c9c-4622-9d4e-2c2a205587ce",
  },
  {
    name: "CYD-poolen",
    id: "cf31dc1a-bc98-4af1-92f6-fa3f737a787a",
  },
  {
    name: "ISYtan",
    id: "61f8b52d-4c93-4217-81c3-3774566d36bb",
  },
  {
    name: "SU00",
    id: "20a98cbc-4551-4888-b503-eb447e3e850f",
  },
  {
    name: "SU01",
    id: "6120e166-b099-4ffc-88ef-855c44b66974",
  },
  {
    name: "SU02",
    id: "1cfdc6fc-cedb-4137-90fe-4b9a692934d6",
  },
  {
    name: "SU03",
    id: "45db0d85-6009-462f-a10e-fd247b48944e",
  },
  {
    name: "SU10",
    id: "5ca53466-ba57-4318-b986-aea662a5f896",
  },
  {
    name: "SU11",
    id: "6b68ad92-ea03-4081-8aad-adde06e440ad",
  },
  {
    name: "SU12",
    id: "adbdcc05-10f3-4ef4-bdee-a0a5ec3794e6",
  },
  {
    name: "SU13",
    id: "31e7befa-e113-4dee-a8a1-0521c930af3f",
  },
  {
    name: "SU14",
    id: "8551a5d7-4e93-4029-81b2-330bb6ce0df4",
  },
  {
    name: "SU15",
    id: "d29ac8af-e2d4-49e7-98f4-492227bf2265",
  },
  {
    name: "SU16",
    id: "773bf91c-53ac-480b-8ae9-0d832fd5c64c",
  },
  {
    name: "SU17",
    id: "1f30bf90-c456-4985-bacd-f289bea8e8b7",
  },
  {
    name: "SU18",
    id: "b2704e2b-b160-411d-a22d-183743211bba",
  },
  {
    name: "Svedberg",
    id: "68e264e5-cae9-46c2-ab0b-9c363dda0528",
  },
  {
    name: "Theorell",
    id: "7e05e180-2090-4952-82f6-6d1467baf09d",
  },
  {
    name: "Darwin",
    id: "7898d425-6349-40c9-999a-cfb205c95999",
  },
  {
    name: "Linné",
    id: "30e26fb8-514b-49cb-9b9e-d17d5d5ed5e0",
  },
  {
    name: "Systemet",
    id: "ccd12a29-11b3-4f9c-b45d-db132b9c6324",
  },
  {
    name: "Humanoidlabbet",
    id: "b47aa5c5-296c-4ff5-9855-1ee31696e181",
  },
] as Room[];
